export default {
  common: {
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات.',
  },
  nav: {
    home: 'الرئيسية',
    products: 'المنتجات',
    about: 'من نحن',
    partnership: 'الشراكة',
    blog: 'المدونة',
  },
  home: {
    text: 'الرئيسية',
    title: 'YOOXPLORE',
    hero: {
      title1: 'تمكين الشركاء العالميين',
      title2: 'تأمين المستقبل من الجو',
      bookDemo: 'احجز عرضاً توضيحياً',
    },
  },
  overview: {
    title: 'نظرة عامة',
    subtitle: 'منصة YOOX S3T للطائرات بدون طيار',
    content: 'YOOX S3T هي طائرة بدون طيار متطورة قادرة على حمل أحمال ثقيلة والطيران بثبات والمناورة بفاعلية. صُممت لتكون من أفضل الطائرات المستقلة في السوق، مع وقت طيران طويل وأداء ممتاز على المدى البعيد، مما يجعلها مثالية للعمليات العسكرية والمهام الصناعية والمهمات الإنسانية.',
    content2: 'بجانب بيع الطائرات بدون طيار، نساعد علامتك التجارية في تحقيق النجاح محلياً من خلال حلول الإنتاج والتجميع المحلية لمساعدتك في بناء نظام إنتاجك الخاص وتحقيق أهدافك.',
  },
  scenarios: {
    title: 'سيناريوهات التطبيق',
    subtitle: 'قابل للتوسع لحالات استخدام صناعية أكثر',
  },
  advantages: {
    title: 'المزايا الرئيسية',
    subtitle: 'مصمم للتوسع وفقاً لمتطلباتك',
  },
  products: {
    title: 'مركز المنتجات',
    intro: 'مقدمة المنتجات',
    subtitle: 'منصات طيران صناعية ومنتجات متكاملة',
    gallery: {
      all: 'الكل',
    },
    contact_business: 'يرجى التواصل معنا للحصول على تفاصيل المنتج',
  },
  about: {
    text: 'من نحن',
    title: 'من نحن',
    teamTitle: 'فريقنا',
    teamSubtitle: 'من كبرى الشركات العالمية',
    teamContent: 'يأتي فريقنا من شركات مثل DJI وYamaha وApple وTesla وغيرها، بخبرة متوسطة تزيد عن عشر سنوات في صناعة الطائرات بدون طيار وفي مجالات الأمن والدفاع.',
    visionTitle: 'رؤيتنا',
    visionSubtitle: 'نساعد علامتك في النجاح محلياً',
    visionContent: 'بجانب بيع الطائرات، نوفر حلول إنتاج وتجميع محلية لمساعدتك في بناء نظام إنتاجك الخاص وتصنيع أفضل الطائرات لتحقيق أهدافك.',
  },
  partnership: {
    title: 'الشراكة',
    primaryCta: 'الجملة & ODM & OEM',
    secondaryCta: 'كن موزعاً',
    qaTitle: 'الأسئلة الشائعة',
  },
  blog: {
    title: 'المدونة',
    heading: 'رؤى وتحديثات',
    subheading: 'أحدث الأخبار حول الطائرات بدون طيار والتوطين واتجاهات السوق.',
    searchPlaceholder: 'ابحث عن مقالات',
  },
  contact: {
    title: 'اتصل بنا',
    title2: 'يسعدنا التواصل معك.',
    content1: 'إذا أردت الحصول على مزيد من المعلومات أو التعاون معنا، يرجى التواصل عبر واتساب أو تيليغرام أو النموذج.',
    whatsappLabel: 'واتساب',
    whatsappValue: 'WhatsApp: <YOUR_WHATSAPP>',
    telegramLabel: 'تيليغرام',
    telegramValue: 'Telegram: <YOUR_TELEGRAM>',
    form: {
      title: 'نموذج التواصل',
      subtitle: 'يسعدنا التواصل معك.',
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      company: 'الشركة',
      country: 'الدولة/المنطقة',
      interestLabel: 'أنا مهتم بـ',
      interests: ['شراء المنتجات', 'أصبح موزعاً', 'OEM/ODM', 'استشارة تقنية', 'أخرى'],
      message: 'احتياجاتك ووصفها',
      submit: 'إرسال',
      submitTip: 'شكراً لتواصلك. سنرد عليك قريباً.',
      submitError: 'فشل الإرسال. يرجى المحاولة مرة أخرى.',
    },
  },
}
